
















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import { vxm } from '@/store';
import { LoadProjectBasic, UpdateProjectParams } from '@/@types/Project';
import dayjs from 'dayjs';

@Component({
  components: {
    OrganizationIcon,
  },
})
export default class OrganizationBasicConfig extends Vue {
  private isOpenUpdateProjectIconModal: boolean = false;
  private projectIconColor: string = 'light-blue lighten-3';
  private projectIconSize: number = 200;
  private projectStartDateMenu = false;
  private projectWillFinishDateMenu = false;

  private projectName: string = '';
  private projectOutline: string = '';
  private projectStartDate: string = '';
  private projectWillFinishDate: string = '';
  private currentProject: LoadProjectBasic | null = null;
  private nowUpdating: boolean = false;

  private async mounted() {
    if (this.projectId) {
      await vxm.theoryApi.projectsStore.fetchProjectBasic(this.projectId);
    }
    const currentProject = vxm.theoryApi.projectsStore.getProjectBasic;
    if (currentProject) {
      this.projectName = currentProject.projectName;
      this.projectOutline = currentProject.projectOutline ?? '';
      const startDate = currentProject?.projectStartDate;
      this.projectStartDate = startDate ? dayjs(startDate).format('YYYY-MM-DD') : '';
      const willFinishDate = currentProject?.projectWillFinishDate;
      this.projectWillFinishDate = willFinishDate ? dayjs(willFinishDate).format('YYYY-MM-DD') : '';
      this.currentProject = currentProject;
    }
  }

  private openExplorer(): void {
    const iconExplorer = this.$refs.iconExplorer as HTMLElement;
    iconExplorer.click();
  }

  private readProfileImage(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files!.length) {
      this.isOpenUpdateProjectIconModal = false;
      return;
    }

    const reader = new FileReader();
    reader.onload = (loadEvent): void => {
      if (loadEvent.target) {
        (this as any).$refs.iconRef.bind({
          url: loadEvent.target.result,
        });
      }
    };
    this.isOpenUpdateProjectIconModal = true;
    reader.readAsDataURL(files![0]);
  }

  private async updateProject() {
    if (!this.currentProject) { return }
    this.nowUpdating = true;
    const updateParam: UpdateProjectParams = {
      projectId: this.currentProject.projectId,
      data: {
        projectName: this.projectName,
        projectIconImage: this.currentProject.projectIconImage,
        projectOutline: this.projectOutline,
        projectStartDate: this.projectStartDate,
        projectWillFinishDate: this.projectWillFinishDate,
        openFlag: Boolean(this.currentProject.openFlag),
      }
    }
    await vxm.theoryApi.projectsStore.updateProjectPart(updateParam);
    this.nowUpdating = false;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }
}
